export const snakeCaseToString = string =>
  string.toUpperCase().split("_").join(" ");

export const stringToSnakeCase = string =>
  string.toLowerCase().split(" ").join("_");
